import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { IonDatetime } from '@ionic/vue';
import { computed, ref, watch } from 'vue';
import { convertTimeToISO8601, formatDate } from '@/utils/dates';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppDatetimePopover',
  props: {
    modelValue: {},
    opts: {}
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const datetimeValue = ref(props.modelValue);
    const cancelText = computed(() => {
      var _props$opts;
      return ((_props$opts = props.opts) === null || _props$opts === void 0 ? void 0 : _props$opts.locale) === 'es-US' ? 'Cancelar' : 'Cancel';
    });
    const clearText = computed(() => {
      var _props$opts2;
      return ((_props$opts2 = props.opts) === null || _props$opts2 === void 0 ? void 0 : _props$opts2.locale) === 'es-US' ? 'Limpiar' : 'Clear';
    });
    const doneText = computed(() => {
      var _props$opts3;
      return ((_props$opts3 = props.opts) === null || _props$opts3 === void 0 ? void 0 : _props$opts3.locale) === 'es-US' ? 'Hecho' : 'Done';
    });
    /**
     * Converts the date from a `DatetimeCustomEvent` to the format specified in the `opts` prop, then emits it.
     */
    function emitDateWithFormat(value) {
      var _props$opts4;
      let date = '';
      if (!((_props$opts4 = props.opts) !== null && _props$opts4 !== void 0 && _props$opts4.format)) date = value != null ? String(value) : '';else if (value) date = formatDate(String(value), props.opts.format);
      emit('update:modelValue', date);
    }
    watch(() => props.modelValue, newValue => {
      var _props$opts5;
      if (newValue && (_props$opts5 = props.opts) !== null && _props$opts5 !== void 0 && _props$opts5.format) datetimeValue.value = convertTimeToISO8601(newValue);else datetimeValue.value = newValue;
    });
    watch(datetimeValue, value => {
      if (value !== props.modelValue) emitDateWithFormat(value);
    });
    return (_ctx, _cache) => {
      const _component_ion_content = _resolveComponent("ion-content");
      const _component_ion_popover = _resolveComponent("ion-popover");
      return _openBlock(), _createBlock(_component_ion_popover, {
        keepContentsMounted: true,
        class: "datetime-popover"
      }, {
        default: _withCtx(() => [_createVNode(_component_ion_content, null, {
          default: _withCtx(() => [_createVNode(_unref(IonDatetime), _mergeProps({
            cancelText: cancelText.value,
            clearText: clearText.value,
            doneText: doneText.value,
            ..._ctx.opts
          }, {
            value: datetimeValue.value,
            "show-default-buttons": true,
            size: "cover",
            preferWheel: "",
            showClearButton: "",
            class: "datetime",
            onIonChange: _cache[0] || (_cache[0] = e => emitDateWithFormat(e.detail.value))
          }), null, 16, ["value"])]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});